import { render, staticRenderFns } from "./ZnSimple.vue?vue&type=template&id=65d5089a&"
import script from "./ZnSimple.vue?vue&type=script&lang=js&"
export * from "./ZnSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports